export default __webpack_public_path__ + "static/media/dev_1.8c9b3096.png";